import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty } from 'lodash';

import Breadcrumb, { breadcrumbElementsPropTypes } from '../Breadcrumb/Breadcrumb';
import PageTitle, { pageTitlePropTypes } from '../PageTitle';
import ChangeComponent from '../ChangeComponent';
import { changeComponentModalPropTypes } from '../ChangeComponentModal';

import './app.scss';

const App = (props) => {
    const {
        pageTitle,
        isTouchable = false,
        breadcrumbElements = [],
        events,
        eventId,
        sportName,
        locale,
        competitionName,
    } = props;

    const titlePanelCss = classNames('app__title-panel', {
        'app__title-panel--mobile': isTouchable,
    });

    return (
        <div>
            <Breadcrumb breadcrumbElements={breadcrumbElements} mobile={isTouchable} />
            {(!isEmpty(pageTitle) || !isEmpty(events)) && (
                <div styleName={titlePanelCss}>
                    <PageTitle pageTitle={pageTitle} mobile={isTouchable} />
                    {!isEmpty(events) && (
                        <ChangeComponent
                            sportName={sportName}
                            eventId={eventId}
                            events={events}
                            locale={locale}
                            competitionName={competitionName}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

App.propTypes = {
    pageTitle: pageTitlePropTypes,
    isTouchable: PropTypes.bool,
    breadcrumbElements: breadcrumbElementsPropTypes,
    ...changeComponentModalPropTypes,
};

export default App;
